import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherWindow, UpdateWeatherWindowDto } from 'types';

export const updateWeatherWindow = async ({
  data,
  windowId,
}: {
  data: UpdateWeatherWindowDto;
  windowId: number;
}): Promise<WeatherWindow> => {
  const { data: savedWindow } = await axios.put(
    `/api/weather/windows/${windowId}`,
    data
  );
  return savedWindow as WeatherWindow;
};

type UseUpdateWeatherWindowOptions = {
  config?: MutationConfig<typeof updateWeatherWindow>;
};

export const useUpdateWeatherWindow = ({
  config,
}: UseUpdateWeatherWindowOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherWindows) {
        queryClient.setQueryData(
          ['weatherWindows'],
          context.previousWeatherWindows
        );
      }
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['weatherWindows']);
      queryClient.invalidateQueries(['weatherWalls', data.weather_wall_id]);
      queryClient.invalidateQueries([
        'weatherWindowLocations',
        data.location_id,
      ]);
    },
    ...config,
    mutationFn: updateWeatherWindow,
  });
};
